var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstronaut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 623,
    viewBox: "0 0 614 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 28.072C186.646 21.718 187.999 17.071 189 12.072C198.35 7.579 211.136 11.987 223 11.072C224.755 12.974 217.8 11.93 217 12.072C205.58 14.1 195.49 22.087 187 28.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 12.072C233.253 10.507 242.975 13.081 251 12.072C251.168 15.254 253.344 19.434 251 22.072C242.36 19.716 237.8 13.27 228 12.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253 12.072C257.918 13.263 258.521 25.016 253 26.072C251.68 22.346 255.42 17.814 253 12.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263 23.072H267C270.08 28.658 274.101 33.304 274 42.072C269.512 41.917 269.827 46.566 270 51.072H264C263.202 49.203 262.329 47.409 262 45.072C266.216 47.616 267.058 43.497 270 42.072C269.294 38.778 268.393 35.679 268 32.072C267.086 29.353 266.141 34.736 263 33.072C260.41 29.217 262.38 28.203 263 23.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248 25.072C252.757 22.843 255.538 34.812 261 32.072C261.08 36.659 263.89 38.515 263 44.072C257.18 38.557 255.42 28.986 248 25.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238 32.072C239.479 32.593 240.521 33.551 242 34.072C241.37 36.504 236.95 34.601 238 32.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 36.072C253.732 35.618 257.554 46.66 258 53.072C253.82 48.915 254.49 39.917 250 36.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 35.072C267.677 36.519 268.93 41.024 267 43.072C263.07 43.376 263.09 35.824 266 35.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181 38.072C180.753 39.158 179.012 38.75 179 40.072C178.027 40.045 178.224 38.848 178 38.072C179.31 36.872 179.57 37.682 181 38.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242 38.072C244.182 37.89 245.182 38.89 245 41.072C244.07 40.004 241.31 40.761 242 38.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128 42.072C128.759 40.419 136.241 40.419 137 42.072C137.23 45.931 128.08 44.312 128 42.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146 82.072C143.119 81.953 139.454 82.618 138 81.072C138.814 76.552 141.404 73.809 144 71.072C143.654 54.392 148.474 42.88 165 43.072C151.42 48.563 145.11 65.283 146 82.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 43.072C179.8 46.126 175.6 41.917 182 43.072V43.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244 44.072C247.008 43.064 245.772 46.3 246 48.072C244.66 47.414 244.14 45.934 244 44.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 47.072C170.387 44.792 175.96 46.699 179 46.072C178.105 47.844 174.941 47.346 176 51.072C172.72 50.688 171.59 48.147 169 47.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 47.072C133.175 46.88 129.362 54.431 133 56.072C131.013 54.406 131.729 56.162 129 56.072C128.46 52.204 130.78 51.19 130 47.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179 131.07C175.953 125.813 180.685 120.168 181 114.07C181.429 105.768 174.656 100.496 174 91.07C177.235 88.638 186.869 92.605 186 86.07C189.228 85.175 187.405 89.332 189 90.07C192.654 90.749 196.271 91.465 201 91.07C199.141 86.262 193.582 85.155 191 81.07C188.945 82.548 194.399 84.937 194 88.07C190.267 88.136 189.14 85.596 187 84.07C183.593 83.33 185.352 87.755 183 88.07C179.442 88.295 177.008 87.396 176 85.07C175.383 79.12 182.3 80.704 181 74.07C177.585 75.322 178.069 80.472 173 80.07C173.22 83.29 171.231 84.301 172 88.07C163.148 89.534 148.959 91.561 139 96.07C136.31 93.636 138.959 88.086 139 85.07C141.969 84.039 146.246 84.316 148 82.07C141.784 65.472 158.922 65.504 158 51.07C160.198 49.934 161.322 47.726 164 47.07C168.857 47.879 170.794 51.61 175 53.07C173.112 57.086 169.436 53.367 166 55.07C165.519 59.918 169.913 60.486 173 59.07C174.365 64.523 176.113 65.101 179 70.07C180.454 68.524 184.119 69.189 187 69.07C189.917 74.718 195.676 74.866 196 81.07C198.356 81.092 198.944 79.347 202 80.07C200.811 84.494 205.094 86.136 208 89.07C206.424 94.494 204.758 99.828 196 98.07C191.38 110.12 184.08 119.48 179 131.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178 48.072C182.122 50.237 178.73 61.194 177 64.072C175.08 60.45 177.51 52.609 178 48.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185 49.072C187.664 53.075 186.684 60.721 189 65.072C185.941 64.346 186.059 66.798 183 66.072C185.452 63.843 188.963 53.884 181 55.072C182.67 53.41 185.05 52.454 185 49.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133 50.072H137C138.17 53.543 131.41 54.721 133 50.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 51.072C103.862 51.21 104.096 54.976 104 59.072C101.57 57.502 100.25 54.817 100 51.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 72.072C297.669 64.519 304.383 59.331 298 54.072C281.072 52.994 267.806 54.884 249 58.072C262.104 52.086 284.581 50.442 302 52.072C302.86 52.879 302.594 54.811 304 55.072C304.31 63.052 303.88 70.282 298 72.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 56.072C137.03 52.375 137.37 59.109 134 56.072V56.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271 57.072C271.772 61.844 269.436 63.508 270 68.072C265.635 67.374 265.554 70.959 262 71.072C262.844 66.916 264.578 63.65 264 58.072C265.29 56.694 268.34 57.082 271 57.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 58.072C291.644 73.6 295.646 79.32 294 98.072C285.036 96.732 289.609 83.776 287 75.072C284.445 66.548 278.944 63.928 275 58.072C284.35 58.243 288.45 55.958 298 58.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181 59.072C182.151 55.837 182.132 61.758 182 63.072C180.85 66.307 180.87 60.386 181 59.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 62.072H132C132.467 64.206 130.571 63.977 129 64.072C129.19 63.262 130 63.075 130 62.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 64.072C282.84 68.232 284.444 79.628 284 93.072C276.021 92.451 271.861 95.808 264 93.072C265.704 91.442 269.017 91.422 270 89.072C269.14 81.278 271.42 71.375 274 64.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265 71.072C270.078 73.896 264.074 81.845 266 88.072H252C256.86 82.927 259.01 75.082 265 71.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309 71.072C308.563 72.302 307.721 73.126 306 73.072C305.53 70.938 307.43 71.167 309 71.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323 72.072C324.015 75.499 315.488 74.454 315 73.072C313.98 69.645 322.51 70.69 323 72.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 85.072C309.928 85.822 319.16 86.468 328 87.072C326.822 92.894 325.426 98.498 323 103.072C313.479 104.217 308.997 101.812 299 102.072C297.42 96.252 298.61 91.502 299 85.074V85.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254 92.072C251.799 96.605 244.973 95.452 241 96.072C230.123 97.769 215.287 99.828 207 98.072C208.079 90.069 230.197 95.17 234 95.072C241.2 94.887 247.3 91.988 254 92.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292 123.07C296.033 116.825 309.155 106.252 314 118.07C306.41 121.814 301.577 128.314 297 135.07C287.476 128.927 277.646 123.091 270 115.07C263.366 115.716 264.95 115.326 259 116.07C255.672 117.072 259.268 120.106 256 122.07C253.56 118.585 255.825 111.262 257 108.07C254.333 103.163 245.53 105.968 240 105.07C238.951 103.119 237.994 101.076 237 99.07C245.396 98.466 256.666 100.736 257 92.07C260.101 93.636 260.815 97.588 264 99.07C276.303 99.375 279.61 98.771 288 101.07C286.229 106.632 279.41 107.147 278 113.07C283.318 107.419 295.348 95.928 303 110.07C300.86 115.94 292.57 115.64 292 123.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 100.07C173.705 101.973 171.347 95.433 170 93.07C174.16 93.246 173.72 98.022 176 100.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174 118.07C178.091 115.878 175.452 106.064 175 102.07C180.251 106.575 180.831 115.883 177 122.07C175.828 121.908 176.157 120.247 176 119.07C175.315 123.692 170.627 123.408 166 126.07C160.356 117.239 161.698 107.22 159 95.07C171.89 89.823 177.35 104.84 174 118.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 96.072H157C158.116 100.622 159.348 105.057 160 110.072C157.57 105.172 151.92 103.482 152 96.074V96.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164 126.07C161.146 127.549 157.381 128.117 155 130.07C149.679 120.391 145.271 109.799 140 100.07C142.711 98.781 145.553 97.623 150 98.07C155.84 106.23 160.89 115.18 164 126.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 103.07C193.756 111.949 198.683 122.357 194 132.07C201.379 126.783 194.798 107.534 203 103.07C202.85 101.22 199.614 102.456 199 101.07C207.599 102.113 224.745 101.112 234 100.07C231.93 104 226.157 104.227 228 112.07C219.742 115.001 216.584 117.486 205 116.07C198.794 120.799 206.656 127.145 205 132.07C201.543 133.747 198.768 132.401 193 133.07C191.105 135.943 191.896 143.043 193 146.07C205.389 147.681 222.481 144.589 225 156.07C214.977 154.093 205.068 152.002 197 148.07C194.14 148.21 195.171 152.241 195 155.07C191.668 155.405 190.564 157.967 186 157.07C186.722 149.126 184.194 137.931 188 133.07C182.683 132.753 184.178 139.248 177 137.07C180.148 130.923 183.528 124.305 187 118.07C190.15 112.42 192.8 104.51 200 103.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 130.07C141.591 132.108 143.403 143.828 143 155.07C139.68 156.295 139.868 155.009 135 156.07C135.487 140.805 127.109 121.857 111 117.07C117.741 105.605 135.281 117.838 138 126.07C139.564 116.83 124.986 115.091 120 109.07C123.856 105.362 130.75 100.564 135 101.07C145.6 102.33 147.54 122.32 153 130.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234 103.07C237.943 101.794 236.597 105.807 238 107.07C243.779 106.625 248.247 107.49 253 108.07C254.645 112.688 252.793 119.839 252 125.07C246.496 125.805 238.459 126.307 229 123.07C227.29 116.46 229.83 106.98 234 103.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302 105.07C307.215 103.212 316.277 106.108 323 106.07C322.488 111.915 325.354 114.382 326 119.07C315.88 116.52 311.37 108.37 302 105.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227 115.07C227.364 118.434 222.667 116.737 221 118.07C220.97 115.04 224.51 115.58 227 115.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 117.07C271.213 115.857 269.879 121.191 270 125.07C266.13 125.09 264.27 119.53 266 117.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133 145.07C133.178 149.447 129.622 144.133 129 143.07C119.026 137.377 116.626 124.111 103 122.07C116.57 109.88 129.82 133.74 133 145.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269 127.07C270.759 126.829 271.279 125.349 271 123.07C277.474 125.738 270.638 130.778 269 134.07C265.167 130.57 259.791 128.613 255 126.07C257.805 124.875 259.39 122.46 259 118.07C266.58 116.83 263.94 125.8 269 127.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315 121.07C307.557 129.96 297.836 136.573 298 153.07C292.77 151.892 296.847 146.429 298 143.07C298.503 141.605 297.404 139.494 298 138.07C300.96 130.99 308.95 122.89 315 121.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317 121.07C325.151 121.919 331.519 124.551 339 126.07C338.709 134.303 339.438 139.984 340 145.07C333.047 143.997 327.31 146.686 318 147.07C317.7 138.37 318.81 128.26 317 121.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264 132.07C261.625 135.022 257.942 130.861 255 131.07C248.653 133.057 247.335 140.071 248 149.07C252.702 154.368 261.361 155.709 272 155.07C271.299 159.438 273.701 160.702 273 165.07C257.416 162.349 224.254 161.757 229 136.07C228.485 132.585 222.466 134.604 219 134.07C216.999 131.071 215.245 127.825 212 126.07C214.582 123.319 220.255 123.658 225 123.07C232.53 131.54 255.7 124.38 264 132.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131 157.07C123.227 157.176 121.022 151.715 118 147.07C109.23 139.648 94.694 142.179 84 143.07C85.818 121.973 106.721 119.75 118 132.07C119.883 134.127 119.976 137.484 122 140.07C126.59 145.94 137.29 150.04 131 157.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 126.07C219.11 134.293 226.773 145.964 234 158.07C223.883 154.558 217.07 139.882 207 133.07C208.38 131.78 207.99 128.73 208 126.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313 165.07C310.021 160.296 314.361 155.433 316 152.07C312.104 150.207 312.559 161.271 307 161.07C302.281 156.14 308.519 149.011 310 144.07C305.277 145.681 307.078 153.815 302 155.07C298.83 141.347 306.179 130.077 316 126.07C313.63 136.57 324.72 160.06 313 165.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176 127.07C174.538 137.608 170.046 145.116 162 149.07C159.271 142.321 167.343 137.761 166 129.07C169.58 128.65 171.34 126.41 176 127.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278 128.07C277.563 129.3 276.72 130.124 275 130.07C274.53 127.94 276.43 128.17 278 128.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286 137.07C283.95 140.073 278.341 139.198 276 137.07C274.74 127.73 286.05 131.24 286 137.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164 133.07C161.566 138.97 160.639 146.376 157 151.07C154.036 148.034 157.964 138.106 155 135.07C155.74 132.22 161.42 130.99 164 133.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253 134.07C270.542 133.617 278.336 138.563 287 148.07C286.453 151.583 281.2 149.675 279 149.07C278.899 143.561 272.076 140.374 268 142.07C270.845 143.559 271.433 147.304 271 152.07C259.957 153.077 257.96 153.079 249 148.07C248.831 145.567 250.536 144.94 252 144.07C251.267 143.136 250.182 142.555 249 142.07C249.31 140.713 251.504 141.24 253 141.07C248.18 137.25 253.33 140.13 253 134.07ZM257 137.07C257.843 141.58 254.66 142.063 254 145.07C255.837 146.567 256.493 149.243 259 150.07C267.15 148.35 265.71 134.49 257 137.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 169.07C145.6 168.727 147.469 157.413 147 150.07C146.683 145.101 144.872 140.47 147 137.07C148.862 136.932 150.342 136.412 151 135.07C152.313 135.424 152.573 136.831 154 137.07C152.33 149.28 155.41 155.95 153 169.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 156.07C168.01 153.393 162.908 154.829 163 151.07C170.054 147.457 171.489 138.226 183 139.07V158.07C174.297 158.045 169.179 166.901 165 168.07C166.11 163.85 168.18 160.59 169 156.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342 139.07C350.187 143.409 353.614 157.193 351 169.07C346.961 165.11 341.932 162.138 335 161.07C337.56 158.577 344.202 160.485 346 162.07C344.748 155.841 335.042 159.088 326 159.07C330.907 154.644 339.772 154.176 343 148.07C342.16 145.58 341.69 142.71 342 139.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 145.07C99.9359 146.006 97.5869 156.657 85.9999 158.07C85.3039 154.399 84.2739 150.467 85.9999 147.07C92.4509 143.18 103.83 141.72 112 145.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263 147.07C259.959 147.111 256.418 147.652 257 144.07C258.97 142.22 264.36 142.58 263 147.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273 147.07C277.518 149.218 278.792 154.612 286 154.07V170.07C273.58 170.49 274.24 157.83 273 147.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319 149.07C325.793 148.196 332.178 146.915 340 147.07C336.477 152.557 323.562 153.952 320 156.07C319.68 153.72 318.42 152.32 319 149.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 151.07H200C200.319 153.389 199.839 154.909 199 156.07C198.196 155.541 197.376 155.027 196 155.07C195.87 153.28 197.22 152.96 197 151.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161 152.07C162.163 154.211 160.388 160.327 157 161.07C156.46 156.39 154.65 151.76 161 152.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201 152.07C204.465 151.938 206.805 152.931 206 157.07C204.093 158.947 204.19 156.477 201 157.07V152.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155 169.07C156.5 163.237 161.885 161.288 163 155.07C165.409 154.661 165.174 156.896 168 156.07C165.76 162.57 163.95 175.32 155 169.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216 156.07V160.07C214.587 161.498 211.143 159.852 209 159.07V156.07C210.89 154.09 213.72 155.59 216 156.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293 156.07C299.749 163.321 311.808 165.262 313 178.07C312.736 181.473 308.496 180.899 307 183.07C306.337 186.741 305.936 190.673 305 194.07C300.441 190.629 302.05 181.02 299 176.07C295.955 174.449 292.342 173.395 290 171.07C289.34 164.41 291.16 160.23 293 156.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193 159.07C195.389 155.106 199.62 159.289 204 159.07C202.15 161.7 196.34 160.64 193 159.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217 157.07H220V160.07H217V157.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221 157.07C223.356 157.048 223.944 158.793 227 158.07C227.725 161.129 225.275 161.011 226 164.07C224.839 163.231 223.319 162.751 221 163.07V157.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 163.07C189.928 163.992 188.039 163.894 185 161.07C186.22 157.33 195.64 158.74 195 163.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 159.07C230.319 158.751 231.839 159.231 233 160.07C233.726 163.129 231.275 163.011 232 166.07C226.41 165.98 227.55 163.71 228 159.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 195.07C179.197 195.312 179.024 189.098 174 189.07C169.896 189.047 165.974 191.35 166 196.07C166.07 208.617 191.309 200.961 203 200.07C191.927 205.653 184.671 211.447 171 210.07C166.543 216.613 163.768 224.838 154 226.07C154.305 209.765 152.231 195.839 153 179.07C155.347 180.056 157.913 180.824 161 181.07C160.847 184.251 158.733 185.469 159 189.07C169.308 187.045 173.052 178.455 177 170.07C183.557 167.627 191.687 166.757 197 163.07C201.205 163.275 205.36 163.43 206 160.07C209.715 163.227 214.314 162.148 219 163.07C227.003 164.644 235.2 170.761 243 172.07C252.278 173.627 262.765 170.637 269 178.07H279C277.455 182.191 270.084 180.487 267 183.07C267.197 186.933 267.036 190.439 266 193.07C271.462 192.119 271.921 188.222 271 183.07C282.264 183.544 286.936 183.617 294 180.07C294.477 184.433 297.165 183.465 297 187.07C296.712 193.354 289.628 192.474 282 192.07C283.92 199.687 281.535 207.103 278 212.07C273.004 211.399 274.586 204.151 272 201.07C268.962 202.303 273.084 204.509 272 207.07C240.576 211.485 228.83 205.374 194 207.07C196.365 203.768 201.974 203.711 206 202.07C207.382 198.022 203.83 198.907 204 196.07C207.111 194.181 207.675 189.745 211 188.07C233.014 187.29 247.071 189.113 264 194.07C252.661 185.953 234.441 186.924 216 186.07C208.24 185.711 196.79 183.681 194 185.07C189.56 187.28 188.39 194.16 184 195.07ZM257 177.07C244.581 172.138 224.43 174.515 212 175.07C201.124 175.555 190.262 174.87 179 179.07C179.261 181.998 176.739 182.142 177 185.07C179.522 188.451 182.238 185.694 187 186.07C187.01 183.414 186.622 180.359 188 179.07C219.896 176.953 236.432 174.088 263 180.07C262.71 176.52 258.81 177.79 257 177.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240 168.07C237.177 169.242 235.753 168.269 233 167.07C233.319 164.722 234.58 163.317 234 160.07C237.247 159.49 238.652 160.751 241 161.07C239.62 162.36 240.01 165.42 240 168.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 165.07C182.143 164.794 177.724 167.783 175 164.07C177.15 161.32 186.93 158.64 187 165.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319 164.07C318.694 161.764 321.889 162.959 322 161.07C324.066 160.873 333.478 161.034 328 162.07C324.36 162.62 323.39 162.78 319 164.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242 162.07H247V167.07C248.777 165.847 247.205 161.275 252 163.07V170.07C245.968 168.025 247.507 170.025 240 170.07C240.53 167.27 241.47 164.87 242 162.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 171.07C118.489 171.553 118.711 172.227 116 171.07C114.438 173.508 113.933 177.003 112 179.07H107C103.894 179.964 105.996 186.066 104 188.07C96.582 188.821 95.398 183.339 93 179.07C96.9 170.56 116.76 154.28 122 171.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317 170.07C318.172 164.114 333.682 161.163 342 164.07C344.186 164.834 345.079 169.497 348 167.07C347.277 170.126 349.022 170.714 349 173.07C337.91 166.82 328.79 162.26 317 170.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253 164.07C255.465 163.938 257.818 163.919 259 165.07C258.911 168.981 257.776 171.846 253 171.07V164.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 165.07H143C141.178 171.892 148.525 169.545 147 176.07C142.6 174.17 137.04 170.26 139 165.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177 169.07C174.37 170.105 170.474 170.656 171 166.07C173.29 163.9 177.24 165.71 177 169.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264 172.07C261.642 170.782 262.14 172.201 259 171.07C258.978 168.714 260.723 168.126 260 165.07C263.056 164.347 263.644 166.092 266 166.07C265.2 167.94 264.33 169.73 264 172.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266 174.07C262.362 170.218 269.001 164.154 273 168.07C272.35 171.76 269.58 173.32 266 174.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344 198.07C344.086 196.651 344.165 195.238 343 195.07C343.768 191.837 345.768 189.837 349 189.07C347.727 184.832 345.738 190.003 342 189.07C340.24 185.639 342.173 182.609 344 180.07C339.88 181.617 338.263 185.666 331 184.07C329.849 182.888 329.868 180.535 330 178.07C326.695 178.099 327.555 182.291 325 183.07C321.079 181.324 316.199 180.538 317 174.07C331.227 157.58 361.623 177.772 349 197.07C346.17 196.25 346.41 198.48 344 198.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279 171.07C277.073 176.224 274.421 177.259 268 176.07C271.86 174.46 274.04 165.56 279 171.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174 174.07C171.255 176.314 166.745 173.921 164 173.07C165.87 170.15 174 168.04 174 174.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 171.07C159.16 170.751 161.754 174.081 160 179.07C156.531 179.872 156.156 177.581 153 178.07V171.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 175.07C280.956 174.787 280.111 178.274 278 176.07C278.39 172.8 283.48 170.32 284 175.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 177.07C117.081 174.901 118.232 177.192 120 178.07C119.571 176.166 117.846 175.558 118 173.07C130.956 174.92 138.697 169.162 144 182.07C131.936 181.215 126.03 183.798 120 179.07C120.332 185.304 120.332 185.836 120 192.07C117.18 188.23 117.09 181.65 115 177.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163 175.07C166.056 174.347 166.644 176.092 169 176.07C168.837 177.233 169.221 177.849 170 178.07C169.879 183.616 165.2 184.603 161 186.07C162.13 182.87 163.03 179.44 163 175.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292 177.07C291.354 180.091 287.458 179.861 286 182.07C283.22 179.55 289.55 177.68 292 177.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283 180.07C283.437 178.84 284.28 178.016 286 178.07C285.56 179.3 284.72 180.12 283 180.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185 180.07C185.422 183.492 182.005 183.075 181 185.07C178.31 183.27 181.65 179.14 185 180.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 181.07C115.821 185.916 117.319 189.084 118 193.07C113.573 193.546 113.027 191.694 110 193.07C109.381 188.689 107.405 185.665 107 181.07H116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 184.07H146V190.07C136.629 189.92 127.719 190.51 122 189.07V184.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314 233.07C305.384 227.529 315.233 213.007 307 206.07C306.162 196.565 312.341 194.078 311 184.07C312.758 184.645 316.875 182.862 317 185.07C320.896 190.731 319.764 199.581 319 210.07C318.36 218.87 319.93 230.42 314 233.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318 186.07C324.324 183.102 331.564 187.821 339 187.07C339.405 191.665 341.381 194.689 342 199.07C336.389 198.039 328.807 197.721 322 197.07C321.03 193.04 320.15 188.92 318 186.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 202.07C100.923 201.091 106.235 185.003 108 187.07C111.16 190.77 106.21 197.29 106 202.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201 188.07C201.431 185.834 205.928 187.665 208 187.07C204.221 190.957 203.571 197.974 197 199.07C196.88 194.5 205.81 190.98 201 188.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 189.07C198.758 192.161 196.699 194.436 194 196.07C191.072 196.331 190.928 193.809 188 194.07C189.17 189.94 194.56 185.72 200 189.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 234.07C107.889 226.087 108.195 218.169 108 207.07C111.708 206.362 112.292 208.778 116 208.07C118.994 207.064 117.974 202.044 119 199.07C121.168 198.902 119.453 202.617 120 204.07C122.295 202.031 120.362 195.765 121 192.07C127.98 190.556 133.894 192.674 146 192.07V213.07C137.811 214.353 130.881 213.508 122 213.07C122.22 209.85 120.231 208.839 121 205.07C118.47 216.87 122.23 234.96 107 234.07ZM130 212.07C130.314 210.718 131.423 210.16 131 208.07H127C126.72 210.69 127.36 212.37 130 212.07ZM141 212.07V208.07H137C136.22 211.52 137.56 212.85 141 212.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 192.07C171.995 192.728 168.044 194.208 169 196.07C166.51 195.92 168.71 192.69 169 192.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 194.07C119.651 191.25 120.161 196.373 120 197.07C119.54 199.08 118.12 197.88 119 194.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147 193.07C148.163 192.907 148.779 193.291 149 194.07C149.681 206.389 150.391 218.679 150 232.07H143C148.17 222.91 147.03 207.44 147 193.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294 193.07C295.615 192.788 295.722 194.015 297 194.07C294.108 209.178 295.756 228.826 292 243.07C282.757 239.647 281.123 228.613 279 218.07C287.271 216.341 284.415 203.485 287 196.07C290.748 203.705 287.535 219.84 287 234.07C291.129 230.84 289.556 224.465 290 214.07C290.291 207.25 291.054 203.188 291 196.07C292.44 195.51 293.44 194.51 294 193.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 194.07C113.22 193.85 114.231 195.839 118 195.07C116.952 198.355 117.521 203.258 116 206.07C111.551 206.853 109.999 204.738 106 205.07C107.86 201.93 107.85 196.92 110 194.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 195.07C302.879 196.943 304.754 203.584 303 208.07C300.591 208.479 300.826 206.244 298 207.07C297.94 201.56 298.04 197.14 299 195.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194 198.07C190.616 200.353 185.558 200.961 180 201.07C179.77 194.66 191.03 195.49 194 198.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173 199.07H175C175.467 201.204 173.571 200.975 172 201.07C172.19 200.26 173 200.08 173 199.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343 204.07C336.222 205.965 326.668 203.758 321 203.07V200.07C326.66 199.28 340.53 198.39 343 204.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 205.07C327.913 206.49 335.505 206.232 342 207.07C342.327 215.734 341.571 220.238 341 226.07C330.812 226.018 331.556 224.876 320 225.07C319.81 217.55 320.45 210.86 322 205.07ZM325 224.07C327.729 224.799 327.013 222.083 329 222.07C329.17 219.567 327.464 218.94 326 218.07C324.79 219.63 322.8 221.97 325 224.07ZM334 224.07C340.519 225.37 341.538 218.453 335 219.07C334.16 220.23 333.68 221.75 334 224.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312 300.07C308.973 298.694 308.428 300.546 304 300.07C297.947 293.044 301.218 283.412 300 274.07C298.742 264.418 293.451 255.949 294 247.07C294.173 244.278 296.449 242.579 297 240.07C299.103 230.498 296.084 220.033 298 211.07C303.331 211.019 306.91 211.177 309 212.07C307.046 222.721 309.148 228.272 312 236.07C313.184 235.777 315.777 232.042 317 235.07C317.17 237.573 315.464 238.2 314 239.07C313.944 243.459 317.309 244.428 318 248.07C315.86 264.38 314.52 281.9 312 300.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175 212.07C175.428 214.832 171.272 213.008 171 215.07C168.05 213.63 172.19 211.04 175 212.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 215.07C132.195 215.271 140.055 214.483 146 217.07C145.284 222.95 139.608 220.088 137 220.07C133.025 220.043 128.594 220.235 122 220.07V215.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182 221.07C181.472 226.208 174.777 225.18 171 227.07C166.807 233.543 160.578 237.982 153 241.07C146.466 228.999 163.739 226.661 168 219.07C171.25 221.15 178.88 218.86 182 221.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 222.07H144C143.635 226.705 141.474 229.545 139 232.07C127.853 231.059 126.645 232.126 117 231.07C117.62 227.36 119.81 225.22 121 222.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230 238.07C229.973 231.745 221.432 228.663 222 225.07C240.588 226.016 252.841 225.878 273 226.07C271.351 229.803 275.257 235.509 280 236.07C276.79 242.78 268.179 240.292 261 241.07C250.269 242.234 238.879 243.605 233 251.07C244.122 243.159 268.328 243.11 282 241.07C284.094 243.282 282.784 247.73 281 249.07C286.633 255.219 286.198 272.156 291 275.07C273.707 269.706 255.257 268.726 239 278.07C238.184 271.553 236.714 265.69 237 258.07C235.306 265.043 234.888 273.292 233 280.07C229.49 278.913 229.935 273.802 230 269.07C225.715 269.118 227.334 275.071 227 279.07C213.76 270.454 190.491 263.416 172 269.07C180.378 261.647 199.803 260.174 212 265.07C208.748 262.527 204.148 260.538 200 260.07C186.298 258.524 172.244 267.43 163 269.07C161.912 264.998 166.215 258.517 169 255.07C184.213 247.491 203.9 249.187 223 252.07C207.272 245.134 183.551 246.099 168 254.07C163.064 244.585 173.233 242.128 172 233.07C186.088 217.387 210.003 236.19 219 247.07C215.577 237.822 202.057 230.017 190 226.07C201.36 222.1 222.66 223.45 230 238.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277 226.07C278.383 228.354 279.038 231.365 280 234.07C275.575 234.829 276.562 230.174 274 229.07C274.11 227.18 277.31 228.38 277 226.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319 227.07C328.995 227.204 332.953 227.18 341 229.07C339.965 231.328 328.885 231.587 322 230.07C320.34 229.71 318.43 229.66 319 227.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170 232.07C172.711 236.815 166.406 241.118 165 245.07C165.595 247.142 163.764 251.639 166 252.07C160.162 259.232 164.687 276.757 152 277.07C150.681 266.084 157.204 262.941 156 252.07C162.12 246.85 164.74 238.15 170 232.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319 232.07C327.083 231.32 332.477 233.26 340 233.07C340.146 238.216 338.022 241.092 336 244.07C326.395 243.436 325.338 244.093 316 242.07C315.31 237.05 320.02 237.42 319 232.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148 238.07C151.049 246.093 153.076 253.54 149 263.07C136.842 262.689 129.332 262.882 123 264.07C120.102 264.613 114.771 261.917 116 268.07C116.587 273.233 122.659 270.664 126 271.07C134.192 272.065 143.181 272.677 148 273.07C148.573 280.976 137.534 277.271 131 278.07C129.226 282.817 129.054 290.398 128 293.07C120.545 291.985 117.053 293.264 107 291.07C105.396 273.492 105.254 252.799 108 237.07C122.11 237.14 138.05 236.63 148 238.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283 239.07C291.513 244.695 289.595 254.177 292 263.07C293.361 268.101 298.17 272.009 297 278.07C285.892 271.887 291.152 258.799 283 250.07C285.14 245.88 284.69 243.59 283 239.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161 240.07C161.55 244.62 158.455 245.525 155 246.07C155.77 242.84 157.77 240.84 161 240.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 265.07C119.307 265.877 118.444 267.809 120 268.07C118.58 272.46 115.88 263.37 120 265.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141 265.07C139.845 266.572 137.49 269.281 141 270.07C136.446 271.596 129.015 268.261 122 268.07C126.77 263.34 130.67 266.1 141 265.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143 266.07C143.125 263.862 147.242 265.645 149 265.07C148.8 268.536 148.167 271.57 144 271.07C144.77 270.39 146.6 265.11 143 266.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226 286.07C215.378 286.47 208.16 274.91 196 273.07C179.535 270.579 167.897 281.549 155 283.07C158.659 273.878 178.352 268.465 194 270.07C203.56 271.05 223.56 277 226 286.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 274.07C238.034 273.703 237.076 277.327 238 279.07C236.206 278.943 235.891 280.294 234 280.07C233.98 277.72 235.72 277.13 235 274.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296 285.07C284.328 279.193 267.062 276.051 253 281.07C250.026 282.132 246.397 284.392 244 286.07C241.037 288.144 238.588 293.621 234 292.07C234.506 277.546 255.755 273.053 272 274.07C281.78 274.68 294.16 277.14 296 285.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208 291.07C195.468 295.11 178.738 295.91 170 306.07C177.035 305.646 190.458 298.367 203 300.07C208.627 300.834 216.429 304.224 217 309.07C218.455 321.416 202.565 316.799 196 323.07C196.594 327.325 199.961 325.004 198 330.07C201.183 331.553 207.327 330.076 210 332.07C204.801 339.538 186.306 333.709 184 344.07C189.495 345.977 206.724 336.935 212 345.07C207.337 350.502 190.004 346.322 187 356.07C193.404 358.714 200.038 354.985 208 356.07C207.248 362.675 199.691 356.88 198 363.07C201.624 365.976 206.56 361.668 212 363.07C213.999 367.571 211.89 373.47 208 375.07C212.25 382.715 207.952 391.799 205 398.07C205.611 402.587 211.396 396.13 211 402.07C201.764 404.458 192.083 398.501 189 411.07C193.282 415.388 200.58 408.893 209 411.07C212.156 423.197 213.375 442.975 206 454.07C204.947 457.79 209.373 456.031 210 458.07C204.704 472.943 187.4 468.531 178 460.07C176.964 442.433 180.808 413.973 171 402.07C168.151 394.072 171.555 383.434 170 377.07C169.31 374.246 166.724 373.011 166 370.07C164.637 364.53 167.257 357.835 163 353.07C165.789 331.45 157.749 307.11 157 289.07C165.234 279.901 185.02 274.133 200 278.07C203.834 277.888 200.363 278.888 201 281.07C203.101 282.302 204.899 283.838 207 285.07C206.57 287.3 204.7 290.49 208 291.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134 281.07C138.565 281.505 145.011 280.059 148 282.07C142.639 281.317 141.923 290.434 137 293.07C136.817 296.603 141.232 298.544 139 301.07C128.64 301.14 130.54 287.2 134 281.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157 304.07C153.941 304.795 154.059 302.345 151 303.07C138.001 312.999 123.241 308.892 105 309.07C102.953 305.783 104.46 298.944 104 294.07C113.379 293.358 120.278 295.125 129 295.07C131.34 298.397 132.406 302.997 136 305.07C139.469 305.872 139.844 303.581 143 304.07C143.123 299.614 140.533 297.87 140 294.07C142.268 292.004 143.552 288.955 145 286.07C156.56 282.19 155.06 295.52 157 304.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228 288.07C233.101 290.302 232.716 298.021 235 303.07C233.936 305.34 228.714 303.451 226 304.07C226.28 298.15 226.85 294.8 228 288.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296 292.07C303.902 296.236 297.851 305.502 297 313.07C296.295 319.338 298.818 326.224 298 333.07C297.761 335.069 296.179 337.162 296 339.07C295.569 343.672 296.653 348.639 296 353.07C294.671 362.081 288.273 369.498 287 378.07C286.146 383.815 286.751 389.074 286 395.07C284.657 405.791 277.777 414.889 277 423.07C275.646 437.32 289.478 455.611 272 463.07C277.125 452.867 275.316 439.159 272 426.07C271.62 422.69 273.733 421.803 275 420.07C272.975 417.428 270.894 414.843 266 415.07C266.353 413.757 267.761 413.497 268 412.07C267.777 408.96 263.023 410.381 260 410.07C271.303 408.523 278.27 397.924 276 386.07C277.302 384.039 280.278 383.681 282 382.07C282.871 374.417 281.366 371.256 282 367.07C279.587 363.671 276.329 366.57 270 365.07C276.212 362.616 283.265 361.002 284 353.07C283.471 352.266 282.957 351.447 283 350.07H276C281.646 346.049 291.199 345.935 294 339.07C292.404 335.333 290.526 331.877 285 332.07C286.581 330.589 288.47 326.901 284 327.07C286.649 325.719 290.416 325.485 292 323.07C290.933 322.137 291.689 319.382 289 320.07C293.862 316.025 288.321 313.299 294 310.07C292.806 307.597 290.576 306.16 288 305.07C288.353 303.757 289.761 303.497 290 302.07C289.303 298.816 285.447 300.274 285 299.07C283.45 291.52 294.77 296.84 296 292.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313 303.07C315.445 307.625 317.512 312.558 320 317.07C311.29 318.75 309.05 317.234 300 317.07C299.02 306.77 302.34 298.82 313 303.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158 308.07C158.809 312.879 153.612 311.682 155 317.07H148C151.898 314.424 144.145 308.561 144 310.07C144.14 308.66 156.27 301.5 158 308.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235 310.07C238.413 328.675 238.076 356.701 233 382.07C232.413 385.007 231.857 389.591 229 391.07C223.968 387.711 227.166 382.129 227 378.07C226.906 375.774 226.138 373.342 226 371.07C224.93 353.381 229.283 337.093 227 312.07C227.354 310.757 228.761 310.497 229 309.07C232.06 308.35 232.64 310.09 235 310.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 311.07C117.939 311.015 125.908 311.081 137 313.07C136.319 319.073 130.191 316.836 126 317.07C119.211 317.449 113.667 315.461 104 316.07V311.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118 347.07C109.82 340.727 101.482 329.17 104 318.07C115.749 317.322 124.403 319.667 136 319.07V328.07C129.787 331.971 115.219 329.627 110 329.07C109.68 334.26 116.87 340.05 118 347.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 319.07C305.011 318.33 298.669 322.756 302 323.07C300.3 326.57 299.43 321.12 300 319.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321 327.07V336.07C311.616 335.971 311.25 334.832 305 336.07C305.888 334.292 307.792 333.528 307 330.07C305.838 325.519 300.797 328.797 300 328.07C304.26 322.77 313.76 328.76 321 327.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303 329.07C307.177 329.739 303.465 335.278 301 332.07C301.35 330.76 302.76 330.5 303 329.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 332.07C116.24 331.513 129.356 331.701 136 333.07C135.271 336.513 134.841 339.687 135 346.07C122.08 355.9 116.51 338.92 111 332.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 334.07C300.89 334.846 302.258 335.145 304 335.07C299.494 337.897 304.056 349.793 298 351.07C298.54 345.28 299.08 339.49 300 334.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305 338.07C310.719 337.351 313.934 339.136 319 339.07C315.273 344.466 312.539 355.777 302 351.07C302.28 346.02 304 342.4 305 338.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 411.07C79.686 413.1 77.899 402.67 66 407.07C60.645 409.05 59.759 414.436 55 414.07C46.771 413.436 48.64 401.429 39 400.07C62.875 393.3 89.267 393.644 113 393.07C108.82 402.23 92.918 399.66 91 411.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227 399.07H230C229.526 402.211 231.247 403.156 233 404.07C232.242 407.716 229.808 403.974 226 405.07C225.98 402.72 227.72 402.13 227 399.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 602.07V610.07C591.222 577.848 556.18 557.89 530 529.07C512.867 516.55 491.97 507.922 475 497.07C468.875 493.153 464.062 487.904 458 484.07C451.764 480.127 443.895 477.841 437 474.07C430.486 470.507 424.473 465.674 418 462.07C404.496 454.552 389.173 448.042 375 442.07C360.291 435.872 344.47 430.777 329 426.07C316.363 422.225 304.138 420.981 293 419.07C289.978 418.551 284.814 418.609 283 415.07C285.554 409.735 291.351 412.875 295 413.07C310.205 413.882 321.631 419.387 333 423.07C383.05 439.281 425.66 460.866 466 485.07C493.802 501.751 521.159 516.442 545 536.07C569.22 556.01 592.74 581.08 614 602.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282 422.07C288.928 424.999 295.087 422.525 302 425.07C302.792 428.528 300.888 429.292 300 431.07C294.114 427.234 289.75 428.807 282 430.07V422.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331 431.07C346.353 432.053 362.688 440.713 378 445.07C374.808 447.878 368.188 447.258 366 451.07C366.318 456.567 368.757 461.955 362 462.07C361.487 457.208 357.306 450.167 348 451.07C346.16 440.58 336.56 437.84 331 431.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504 514.07C502.601 517.581 495.336 515.496 490 515.07C479.953 502.361 466.72 499.453 447 500.07C444.502 495.902 440.496 493.241 437 490.07C432.322 488.498 433.678 490.899 429 491.07C420.996 488.741 414.267 485.136 403 486.07C399.257 487.533 397.084 492.18 393 494.07C390.62 495.172 387.2 494.278 385 495.07C379.027 497.22 372.096 502.85 371 508.07C369.345 515.956 374.793 518.692 375 530.07C371.97 532.122 369.03 527.171 366 526.07C360.878 525.382 358.877 526.393 354 523.07C349.968 525.328 347.087 522.4 344 523.07C336.218 524.758 334.337 535.24 326 533.07C325.967 530.037 329.509 530.579 332 530.07C336.557 524.96 341.173 519.91 342 511.07C350.037 504.44 368.514 508.251 366 491.07C372.906 486.559 381.085 486.732 390 486.07C395.201 482.667 398.746 474.32 397 467.07C395.993 462.887 392.321 462.22 392 458.07C400.254 450.015 418.595 464.179 426 469.07C435.686 475.466 445.083 478.732 453 483.07C461.994 487.998 469.126 495.188 477 500.07C486.31 505.84 494.73 510.43 504 514.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516 534.07C515.156 529.892 517.943 529.347 518 526.07C531.471 532.599 538.427 545.643 551 553.07C537.22 556.04 528.22 539.09 516 534.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178 31.072C173.641 31.989 175.132 37.911 176 40.072C173.392 41.713 171.669 40.264 167 41.072C167.177 34.249 170.382 30.454 173 26.072C167.164 25.916 168.639 41.7 159 41.072C160.602 32.53 164.457 29.905 164 21.072C174.253 19.991 178.073 12.478 183 6.072C207.72 2.833 231.978 8.32 257 8.072C262.241 12.132 263.706 24.313 259 30.072C255.732 26.522 260.159 14.948 256 10.072C231.954 10.333 213.558 8.186 188 8.072C186.275 20.133 183.649 33.466 184 42.072C181.3 41.555 185.44 31.511 178 31.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241 19.072C225.311 11.716 201.098 19.752 191 30.072C192.866 37.272 187.648 37.387 187 42.072C187.685 40.347 184.639 37.189 185 35.072C185.862 30.018 203.583 15.846 216 14.072C225.68 12.689 234.93 14.393 241 19.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244 28.072C243.512 25.185 248.852 32.102 251 33.072C248.67 35.337 246.34 29.12 244 28.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9996 43.072C101.023 43.383 105.777 41.962 106 45.072C108.762 45.5 106.938 41.344 109 41.072C111.88 41.191 115.546 40.526 117 42.072C117.639 46.568 114.27 50.612 117 54.072C123.489 54.228 120.745 45.15 123 41.072C129.321 41.418 127.656 49.749 128 56.072C130.169 57.57 133.629 57.777 137 58.072C135.699 65.208 137.997 76.407 136 83.072C130.1 86.528 117.818 84.453 112 86.072C108.625 80.107 108.839 73.417 106 67.072C102.49 59.237 92.7086 52.461 97.9996 43.072ZM105 63.072C105.873 56.532 107.562 44.127 99.9996 47.072C96.9086 53.188 101.8 59.917 105 63.072ZM113 63.072C115.798 60.03 124.808 63.114 125 60.072C119.194 58.151 115.581 60.168 111 60.072C110.99 62.728 111.378 65.783 110 67.072C116.768 66.343 124.834 67.849 124 63.072C122.02 65.888 114.27 66.069 113 63.072ZM128 66.072C131.733 66.471 133.868 65.273 134 62.072C131.3 58.055 124.81 61.402 128 66.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183 44.072C189.144 44.274 204.683 43.714 208 50.072C202.11 49.485 190.74 46.104 183 44.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301 47.072C305.35 47.055 309.997 46.741 313 48.072C316.117 52.289 314.409 61.33 319 64.072C326.046 62.32 318.195 47.933 325 48.072C328.948 51.071 326.691 57.157 327 62.072C327.461 69.395 328.727 77.681 328 85.072C317.215 84.576 307.477 83.726 299 83.072C298.205 72.348 307.328 67.63 306 58.072C305.3 53.023 300.98 53.601 301 47.072ZM304 75.072C308.443 75.515 311.441 74.513 311 70.072C307.11 67.239 302.94 68.271 304 75.072ZM314 76.072H325C325.876 72.531 325.124 73.613 326 70.072C323.302 68.104 317.262 69.477 313 69.072C313.01 71.728 312.62 74.783 314 76.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258 58.072C260.234 73.311 250.882 85.617 240 91.072C238.865 90.882 239.445 90.069 240 90.072C249.68 83.082 256.03 72.766 258 58.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227 119.07C226.774 120.51 224.015 119.419 224 121.07C221.49 120.65 224.96 118.21 227 119.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278 125.07C279.481 126.922 283.168 126.568 283 130.07C281.42 128.32 278.41 128 278 125.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 129.07C288.038 132.232 298.296 138.039 292 145.07C293.58 138.89 286.19 134.66 284 129.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197 139.07C194.233 138.64 196.948 135.924 199 137.07C198.739 139.998 201.261 140.142 201 143.07C198.37 143.6 199.03 135.84 197 139.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9998 168.07C93.7638 171.306 98.2358 168.834 96.9998 172.07C94.8888 172.959 94.0438 175.114 90.9998 175.07C90.1688 171.755 91.4808 167.631 86.9998 166.07C86.2768 163.014 88.0218 162.426 87.9998 160.07C98.4498 157.187 99.9248 145.328 116 148.07C120.195 157.875 135.149 156.921 134 172.07C131.097 171.32 127.423 170.988 125 172.07C122.071 165.999 118.471 160.599 112 158.07C106.908 158.645 104.34 161.743 102 165.07C104.54 166.236 107.095 158.862 113 160.07C107.58 165.28 102.75 166.74 94.9998 168.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289 173.07C286.805 174.875 284.901 176.971 282 178.07C280.63 180.08 285.08 172.26 289 173.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173 192.07C174.282 189.278 177.761 192.527 178 194.07C180.05 196.46 175.4 191.54 173 192.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 211.07C273.66 216.077 277.81 216.593 277 222.07C248.471 223.446 214.955 217.779 188 222.07C183.798 218.554 174.736 216.507 171 218.07C173.906 214.082 184.453 210.955 192 210.07C215.7 207.29 249.64 212.32 274 211.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204 281.07C210.215 280.868 217.296 288.431 224 291.07C217.76 312.668 227.004 332.22 220 352.07C221.258 357.75 222.335 365.48 222 375.07C221.92 377.359 219.911 379.262 220 381.07C220.346 388.064 224.122 395.106 222 404.07C221.11 407.828 217.652 410.499 217 414.07C214.828 425.965 217.897 439.945 217 450.07C216.597 454.615 216.313 462.288 210 464.07C211.128 460.227 213.757 454.856 208 454.07C214.233 441.904 214.827 421.222 211 409.07C203.634 407.508 197.591 410.132 192 410.07C192.825 399.561 215.305 410.708 214 398.07C212.812 395.593 209.667 396.266 208 398.07C207.201 392.391 215.177 382.666 210 375.07C214.801 374.537 215.307 369.711 215 364.07C213.992 361.745 211.558 360.845 208 361.07C208.309 358.712 211.473 359.21 211 356.07C204.383 351.253 199.521 355.622 191 355.07C193.683 346.753 211.189 353.259 215 346.07C211.687 336.703 205.723 340.248 196 340.07C199.647 335.717 211.295 339.366 213 333.07C216.828 331.841 210.047 331.044 210 330.07C209.981 329.693 212.817 327.82 213 328.07C210.167 324.195 207.428 325.324 200 324.07C206.991 320.06 217.691 319.76 220 311.07C216.226 296.478 193.591 296.144 180 302.07C186.646 295.049 202.227 296.964 211 292.07C208.44 288.63 208.74 282.33 204 281.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M284 310.07C283.903 308.168 280.097 310.69 280 312.07C280.189 315.881 287.387 312.683 289 315.07C285.81 318.574 288.312 319.601 289 324.07C282.448 324.398 280.063 323.18 275 324.07C274.053 327.683 278.938 325.465 281 326.07C279.969 328.556 274.82 328.843 274 326.07C270.175 332.881 280.671 328.594 284 328.07C284.118 331.854 278.153 329.556 278 333.07C279.711 335.358 285.633 333.437 289 334.07C289.576 336.161 291.479 336.924 291 340.07C287.308 345.378 276.664 343.734 274 350.07C274.14 352.93 278.171 351.899 281 352.07C282.621 362.025 272.39 360.127 268 364.07C268.753 369.157 276.837 366.999 280 367.07C280.185 370.004 280.986 374.446 281 380.07C279.131 380.868 277.337 381.741 275 382.07C277.481 391.056 273.593 396.882 269 405.07C263.221 407.193 259.432 405.349 256 410.07C257.718 412.018 261.178 412.225 265 412.07C261.244 416.556 268.32 416.893 271 418.07C267.963 425.517 273.972 435.385 274 445.07C274.006 447.133 272.294 447.983 272 450.07C271.227 455.567 274.36 459.644 270 464.07C262.337 463.636 252.507 463.296 247 459.07C236.652 451.131 239.49 428.925 238 413.07C237.611 408.934 235.272 403.796 235 401.07C233.625 387.296 239.865 369.831 241 354.07C242.447 333.982 242.281 316.69 238 297.07C247.775 280.015 278.458 276.888 295 289.07C294.275 294.679 284.203 290.939 283 296.07C282.582 299.488 283.302 301.768 287 301.07C281.72 307.168 291.102 304.869 291 311.07C289.11 310.87 281.12 311.75 284 310.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303 320.07C305.503 319.599 315.309 320.403 321 320.07C319.876 330.021 310.225 322.402 303 324.07C303.29 323.46 305.49 320.22 303 320.07ZM316 323.07C317.485 324.644 320.468 324.184 320 321.07C317.72 320.79 316.24 321.31 316 323.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 339.07C194.898 341.635 191.273 340.677 190 342.07C187.96 341.24 193.17 339.33 195 339.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107 79.072C111.396 81.342 109.631 89.774 110 96.072C112.474 95.213 109.706 89.112 112 88.072C119.096 86.399 129.918 86.918 136 87.072V97.072C125.771 95.883 118.594 107.155 110 101.072C107.879 106.449 112.882 104.597 116 104.072C113.987 107.059 112.746 110.818 107 110.072C105.69 102.492 107.78 91.316 107 79.074V79.072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 614,
    height: 622.072,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronaut);
export default __webpack_public_path__ + "static/media/astronaut.24ad2ead1a7c5c8a8d0681cbc35548f2.svg";
export { ForwardRef as ReactComponent };